import FalconCloseButton from '@/components/common/FalconCloseButton';
import { Modal } from '@/components/common/AppModal';
import { Button } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { hideconflictModal } from '@/app/KeywordTracker/reducers/conflictModal';
import _ from 'lodash';
import AgGridWrapper from '@/app/common/components/ag-grid/AgGridWrapper';
import URLRenderer from '@/app/common/components/CellRenderers/URLRenderer';
import { trackerTooltips } from '@/app/KeywordTracker/tooltip/trackerTooltips';
function ConflictModal() {
  const dispatch = useDispatch();
  const conflictData = useSelector(state => state.conflictModal);
  return (
    <>
      <Modal
        show={conflictData?.keyword}
        onHide={() => dispatch(hideconflictModal())}
        backdrop="static"
        size="lg"
        keyboard={false}
      >
        <>
          <Modal.Header>
            <Modal.Title> مغایرت با صفحه هدف </Modal.Title>
            <FalconCloseButton onClick={() => dispatch(hideconflictModal())} />
          </Modal.Header>
          <Modal.Body>
            <div className="fs-0 lh-lg">
              صفحه هدف شما در کلمه کلیدی{' '}
              <strong> {conflictData?.keyword}</strong> ارزان با صفحه پیدا شده
              مغایرت داره.
              <br />
              <div className="fs--1">
                ممکنه این موضوع به خاطر وجود مشکلات سئویی در سایت شما باشه. به
                همین منظور بهتره صفحات اشاره شده و کلمه کلیدی رو مورد بررسی مجدد
                قرار بدی.
              </div>
            </div>
            <div className="mt-3">
              <AgGridWrapper
                height="85px"
                settings={{ pagination: false }}
                data={conflictData?.data}
                columns={[
                  {
                    searchable: true,
                    flex: 1,
                    field: 'landing_url',
                    tooltip: trackerTooltips.mainGrid.columns.landing_url,
                    type: 'string',
                    title: 'صفحه هدف',
                    cellRenderer: params => <URLRenderer url={params.value} />
                  },
                  {
                    flex: 1,
                    searchable: true,
                    field: 'found_url',
                    type: 'string',
                    title: 'صفحه پیدا شده',
                    cellRenderer: params =>
                      params.value && (
                        <div className="d-flex align-items-center gap-2">
                          <URLRenderer url={params.value} />
                        </div>
                      )
                  }
                ]}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => dispatch(hideconflictModal())}
            >
              بستن
            </Button>
          </Modal.Footer>
        </>
      </Modal>
    </>
  );
}
export default ConflictModal;
